module.exports = __webpack_public_path__ + "img/pdf1.7f84e707.jpg";